import WorkSpaceNavigateInvoice from '../../../../ogd/myworkspace/Invoice/WorkSpaceNavigateInvoice';

export const croIndividualAccountsHeader = (croView) => {
  return [
    {
      field: 'sl_no',
      headerName: 'Sl No',
      width: 90,
    },
    {
      field: 'student_name',
      headerName: 'Student Name',
      width: 200,
      sortable: true,
      toolTipGetter: true,
    },
    {
      field: 'student_mob_no',
      headerName: 'Mobile No',
      width: 150,
    },
    {
      field: 'course_name',
      headerName: 'Course',
      width: 250,
      sortable: true,
      toolTipGetter: true,
    },
    {
      field: 'opening_balance',
      headerName: 'Opening Balance',
      width: 170,
    },
    {
      field: 'fee_paid',
      headerName: 'Fees Paid',
      width: 150,
      sortable: true,
    },
    {
      field: 'expected_sessions_count',
      headerName: 'Expected Sessions',
      width: 190,
    },
    {
      field: 'no_of_sessions',
      headerName: 'No of Sessions',
      width: 160,
    },
    {
      field: 'total_fee',
      headerName: 'Total Fee',
      width: 150,
      sortable: true,
    },
    {
      field: 'balance',
      headerName: 'Balance',
      width: 140,
      sortable: true,
    },
    ...(croView
      ? [
          {
            field: 'accounts_notes',
            headerName: 'Notes',
            width: 200,
            toolTipGetter: true,
          },
          {
            field: 'ledgerNavigate',
            headerName: 'Close Ledger',
            type: 'action',
            actionType: 'navigate',
            actionKey: 'ledgerNavigate',
            width: 180,
            buttonName: 'Close Ledger',
          },
          {
            field: 'addNote',
            headerName: 'Add Note',
            type: 'action',
            actionType: 'add',
            actionKey: 'addNote',
            width: 120,
            buttonName: 'Note',
          },
          {
            field: 'Invoice',
            headerName: 'Download',
            width: 140,
            buttonName: 'Download',
            renderCell: ({ row }) => (
              <WorkSpaceNavigateInvoice
                rowData={{ ...row, is_currency: row?.invoice_currency, admnNo: row?.admn_no }}
              />
            ),
          },
        ]
      : []),
  ];
};
